import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductUnitService } from '../product-unit.service';
import { HttpService } from '../../http.service';
import { GlobalService } from '../../global.service';

@Component({
  selector: 'app-product-unit-register',
  templateUrl: './product-unit-register.component.html',
  styleUrls: ['./product-unit-register.component.scss']
})
export class ProductUnitRegisterComponent {

  product_unit_register_form: FormGroup;
  action: 'register' | 'update' = null;

  constructor(private formBuilder: FormBuilder, public productUnitService: ProductUnitService, private http: HttpService, private global: GlobalService) {
    this.product_unit_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
      display_name: [null, Validators.compose([Validators.required])]
    });

    if (this.productUnitService.get_product_unit_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.productUnitService.get_product_unit_data);
    }

    this.productUnitService.productUnitUpdate.subscribe((zone) => {
      if (zone === null) {
        this.action = 'register';
        this.product_unit_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(zone);
      }
    });
  }

  registerProductUnit() {
    this.http.registerProductUnit(this.product_unit_register_form.value).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.productUnitService.downloadProductUnit.emit(true);
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(product_group) {
    this.product_unit_register_form.controls['id'].setValue(product_group['id']);
    this.product_unit_register_form.controls['name'].setValue(product_group['name']);
    this.product_unit_register_form.controls['display_name'].setValue(product_group['display_name']);
  }

}
